export default __webpack_public_path__ + "static/media/position.4d8c6552.png";